import React from 'react';
import merchandiseImage from '../assets/images/merchandise.jpg';
import { merchandiseSources } from '../assets/images/responsiveImages';
import '../assets/css/merchandise.css';

const merchandiseUrl = 'https://store.breakspoll.com';

const MerchandiseSection = () => {
  return (
    <section id="merchandise" className="merchandise-section section-breakpoint">
      <div className="merch-card">
        <div className="merch-content">
          <div className="merch-text">
            <p>BREAKSPOLL</p>
            <span>MERCH DROP</span>
            <span>WORLDWIDE SHIPPING</span>
          </div>
          <a className="merch-button" href={merchandiseUrl}>
            SHOP NOW
          </a>
        </div>
        <a
          className="merch-image"
          href={merchandiseUrl}
          aria-label="Shop Breakspoll merchandise"
        >
          <picture>
            <source
              type="image/webp"
              srcSet={`${merchandiseSources.small} 540w, ${merchandiseSources.large} 1086w`}
              sizes="(max-width: 768px) calc(100vw - 64px), 44vw"
            />
            <img
              src={merchandiseImage}
              alt="Model wearing Breakspoll merchandise"
              loading="lazy"
              decoding="async"
            />
          </picture>
        </a>
      </div>
    </section>
  );
};

export default MerchandiseSection;
